import React from 'react'

import { makeStyles } from '@material-ui/core/styles'
import { DisplayScoirApplyIcon } from '@scoir/college-details/icons'

const useStyles = makeStyles({
  icon: {
    fontSize: '21px',
    marginBottom: '-10px',
  },
})

/**
 * ScoirApplyIcon version of sidebar for responsive designs
 * @returns ScoirApplyIcon Component
 */
const ScoirApplyIcon = () => {
  const classes = useStyles()
  return (
    <DisplayScoirApplyIcon
      className={classes.icon}
      isScoirApplyEnabled
    />
  )
}

export default ScoirApplyIcon
